import React, { TextareaHTMLAttributes } from 'react'
import { FieldValues, UseFormRegisterReturn, FieldName } from 'react-hook-form'
import { Container, Field } from './styles'

export interface TextAreaFormProps<T extends FieldValues> extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  register: UseFormRegisterReturn<FieldName<T>>
  large?: boolean
}

export const TextAreaForm = <T extends FieldValues>({
  register,
  large,
  onFocus
}: TextAreaFormProps<T>): JSX.Element => {
  return (
    <Container>
      <Field
        {...register}
        large={large}
        onFocus={onFocus}
        placeholder="Forneça o máximo de detalhes possível, mas não inclua nenhuma informação privada e/ou sensível do paciente."
      />
    </Container>
  )
}
